import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-flooring-area-rugs',
  templateUrl: './icon-flooring-area-rugs.component.html',
  styleUrls: ['./icon-flooring-area-rugs.component.scss']
})
export class IconFlooringAreaRugsComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
